var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',_vm._b({staticClass:"mb-2 mt-2",attrs:{"icon":_vm.icon,"type":_vm.type,"border":"left","data-cy":"alert"}},'v-alert',_vm.$attrs,false),[_c('h3',{staticClass:"font-weight-medium text-left"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }